import { render } from "./RenderFeedbackAndNotes.vue?vue&type=template&id=2217a5f6&scoped=true"
import script from "./RenderFeedbackAndNotes.vue?vue&type=script&lang=js"
export * from "./RenderFeedbackAndNotes.vue?vue&type=script&lang=js"

import "./RenderFeedbackAndNotes.vue?vue&type=style&index=0&id=2217a5f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2217a5f6"]])

export default __exports__